const langButtons = document.querySelector('.lang-button');
const langList = document.querySelector('.lang-list');
if (langButtons && langList) {

  function toggleLanguageMenu() {
    langButtons.classList.toggle('lang-button_disable');
    langList.classList.toggle('lang-list_show');
  }

  langButtons.addEventListener('click', function (e) {
    e.stopPropagation();
    toggleLanguageMenu();
  });

  document.addEventListener('click', function (e) {
    if (
      langButtons.classList.contains('lang-button_disable') &&
      !langButtons.contains(e.target) &&
      !langList.contains(e.target)
    ) {
      toggleLanguageMenu();
    }
  });
}

document.querySelectorAll('.faq_item_title').forEach(title => {
  title.addEventListener('click', () => {
    const thisElem = title.closest('.faq_item');

    thisElem.parentElement.querySelectorAll('.faq_item').forEach(item => {
      if (item !== thisElem) {
        item.classList.remove('active');
        const content = item.querySelector('.faq_item_content');
        if (content) {
          content.style.maxHeight = null;
        }
      }
    });

    const content = thisElem.querySelector('.faq_item_content');
    if (thisElem.classList.contains('active')) {
      thisElem.classList.remove('active');
      if (content) content.style.maxHeight = null;
    } else {
      thisElem.classList.add('active');
      if (content) content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});
